<school-homeside-ui [title]='titlemsg' [shortdesc]='shortdescmsg'></school-homeside-ui>
